module.exports = __webpack_public_path__ + "static/media/galerija_2019 (42).9e424806.jpg";